import request from '@/utils/request'

// 查询合同模板列表
export function listContractTemplates(data) {
  return request({
    url: '/crmContractTemplate/list',
    method: 'post',
    data
  })
}

// 查询合同模板详情
export function getContractTemplateDetail(id) {
  return request({
    url: `/crmContractTemplate/detail/${id}`,
    method: 'get'
  })
}

// 保存合同模板
export function saveContractTemplate(data) {
  return request({
    url: '/crmContractTemplate/save',
    method: 'post',
    data
  })
}

// 删除合同模板
export function removeContractTemplate(id) {
  return request({
    url: `/crmContractTemplate/remove/${id}`,
    method: 'post'
  })
}
